import React, { useState, useRef, useEffect } from 'react';
import { StyleSheet, Text, View, Image, Dimensions, ActivityIndicator } from 'react-native';
// Import the main component
import { Viewer , Worker } from '@react-pdf-viewer/core';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';

import { Modal, Button } from 'antd';
import $ from "jquery";
//import { Modal, Button } from "react-bootstrap";

// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import './css/watermark.css'
import getUserId from "../../shared/core/GetToken"
import Iframe from './Iframe';

import Settings from "../../shared/config/Settings";
import { useDispatch, useSelector } from 'react-redux';
import { appServices } from '../../shared/redux/actions/appServices';


const LetterHandler = props => {
  
    const [checkFile, setCheckFile] = useState(false);
      const dispatch= useDispatch()
      const {LetterAndDocumentByIDData , isLetterAndDocumentByIDData}= useSelector((state)=>state.LetterAndDocumentByID)
    const [dimension, setDimension] = useState(Dimensions.get('window'));
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    //const [checkFile, setCheckFile] = useState(false);

  


    // const [visible, setVisible] = useState(false);
    // const [isLoadingPdf, setIsLoadingPdf] = useState(false);
   
    
 
    
    // const displayLetter = letterId => {
    //     // alert(letterId)
    //     setIsLoadingPdf(true);
    //     var requestOptions = {
    //         method: 'GET',
    //         redirect: 'follow'
    //     };

    //     getUserId().then((userInfo) => {
    //         const item = JSON.parse(userInfo);
    //         setusername(item.username)
    //         fetch(Settings.apiUrl + "Patient/LetterAndDocumentByID?Token=" + item.token + "&PatientID=" + item.userid + "&ResultID=" + letterId, requestOptions)
    //             .then(data => data.json())
    //             .then(json => {
    //                 console.log(JSON.stringify(json))
    //                 if (json[0].entry[0].resource.content[0].attachment.contentType == "PDF") {
    //                     setPdfVisible(true)


    //                     // console.log('Hello:', json[0].entry[0].resource.resourceType)
    //                     //alert(json[0].entry[0].resource.resourceType);
    //                     var b64 = json[0].entry[0].resource.content[0].attachment.data;
    //                     // var bin = atob(b64);

    //                     // // Embed the PDF into the HTML page and show it to the user
    //                     var obj = document.createElement('object');
    //                     obj.style.width = '100%';
    //                     obj.style.height = '550px';
    //                     obj.type = 'application/pdf';
    //                     obj.data = 'data:application/pdf;base64,' + b64;
    //                     //document.body.appendChild(obj);

    //                     // `base64String` is the given base 64 data
    //                     const blob = base64toBlob("data:application/pdf;base64," + json[0].entry[0].resource.content[0].attachment.data);
    //                     const url = URL.createObjectURL(blob);
    //                     setFile(url)
    //                     console.log(url , "url1111111")
    //                     setFile((state) => {
    //                         return state;
    //                     });
    //                     // document.getElementById("showPDF").appendChild(obj)
    //                     setIsLoadingPdf(false);


    //                     return;
    //                 } else {
    //                     var decodedHTML = atob(json[0].entry[0].resource.content[0].attachment.data)
    //                     console.log("NewVaritan" + decodedHTML)
    //                     setVisible(true)
    //                     setHtmlLetter(decodedHTML)
    //                     setHtmlLetter((state) => {
    //                         return state;
    //                     });
    //                     //document.getElementById("showPDFLetters").innerHTML = decodedHTML

    //                     setIsLoadingPdf(false);
    //                 }

    //             })
    //             .catch(error => console.log('error', error)).finally(() => {
    //                 setCheckFile(false)
    //                 setIsLoadingPdf(false)

    //             });
    //     });
    // }

    useEffect(() => {

        const onDimensionsChange = ({ window }) => {
            let wrapperWidth = $('.grid-items-wrapper').width();
            let maxCards = Number((wrapperWidth / 210).toFixed(0));
            let cardWidth = (100 / maxCards).toFixed(2);
            $('.drive-item').css('width', 'calc(' + cardWidth + '% - 30px)');
        }

        Dimensions.addEventListener('change', onDimensionsChange)

        return () => Dimensions.removeEventListener('change', onDimensionsChange)

    }, [])

    // function printDoc() {



    // }

    // function handlePrint() {



    //     //var divContents = document.getElementById("showPDFLetters").innerHTML;
    //     //alert(divContents)
    //     var a = window.open();
    //     // a.document.write('<html>');
    //     // a.document.write('<body > <h1>Div contents are <br>');
    //     a.document.write(htmlLetter);
    //     // a.document.write('</body></html>');
    //     a.document.close();
    //     //a.print();
    //     //  a.close();
    //     //setTimeout(a.close, 0);

    //     setTimeout(function () { a.print(); }, 500);
    //     a.onfocus = function () { setTimeout(function () { a.close(); }, 500); }
    // }



   

    //print configrations
    
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    return (
        <div className="drive-item module text-center">
            <div className="drive-item-inner module-inner">
                <div className="drive-item-title">
                    <a>{props.letterDetail}</a>
                    <p><small>Added: {props.letterDate}</small></p>
                </div>
                <div className="drive-item-thumb">
                    <a ><i className="fa fa-file-pdf-o text-danger" /></a>
                    {(isLetterAndDocumentByIDData && props.selectedID ===props.letterId) && <View style={{ paddingTop: 20 }}><ActivityIndicator size="small" color="#00A1DE" /></View>}
                </div>
            </div>
            <div className="drive-item-footer module-footer">
                <ul className="utilities list-inline">
                    <li><a onClick={() =>{ 
                        dispatch(appServices.LetterAndDocumentByID({
                            PatientID: Profile[0].resource.id,
                            ResultID :props.letterId 
                        }))
                        // displayLetter(props.letterId)
                        }} data-toggle="tooltip" data-placement="top" title data-original-title="Download">View </a></li>
                </ul>
            </div>


            {/* {
                visible && <Iframe content={htmlLetter} />
            } */}
      




        </div>
    );
}
export default LetterHandler
